import { Box } from "@chakra-ui/react";
import { renderBioHtml } from "../utils/bioMarkdown";
import { BIO_CONTENT_CSS } from "./bioContentCss";

/**
 * Read-only render of a creator bio. `bio` is markdown; it is parsed by `marked`
 * and then sanitized by DOMPurify against a tight tag allowlist inside
 * `renderBioHtml`, so nothing reaches `innerHTML` unsanitized. Do NOT pass raw
 * html here and do NOT bypass `renderBioHtml`.
 *
 * Renders nothing when the bio is empty so the caller keeps control of its own
 * empty-state fallback.
 */
export default function BioView({ bio }: { bio: string | null }) {
  if (!bio) return null;
  return (
    <Box
      wordBreak="break-word"
      css={BIO_CONTENT_CSS}
      dangerouslySetInnerHTML={{ __html: renderBioHtml(bio) }}
    />
  );
}
